//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Motion/Motion.SelectControlPort.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"AccelerationExpression",0,"Expression",0],[1,"AmplitudeExpression",0,"Expression",0],[1,"ControlAccelerationPort",0,"Motion.SelectControlPort",0],[0,"ControlAccelerationPortOvrCtrl",1,0],[1,"ControlInitialAccelerationExpression",0,"Expression",0],[1,"ControlInitialVelocityExpression",0,"Expression",0],[1,"ControlPort",0,"Motion.SelectControlPort",0],[0,"ControlPortOvrCtrl",1,0],[1,"ControlVelocityPort",0,"Motion.SelectControlPort",0],[0,"ControlVelocityPortOvrCtrl",1,0],[1,"DisplacementExpression",0,"Expression",0],[1,"FrequencyExpression",0,"Expression",0],[0,"Function",1,"NXObject",0],[1,"HarmonicDisplacementExpression",0,"Expression",0],[1,"InitialDisplacementExpression",0,"Expression",0],[1,"InitialVelocityExpression",0,"Expression",0],[0,"IntegrationTypeOption",1,0],[1,"JerkExpression",0,"Expression",0],[0,"Motor",1,"Motion.PMDCMotor",0],[1,"PhaseAngleExpression",0,"Expression",0],[1,"Profile",0,"Motion.SelectFieldData",0],[0,"SignalChart",1,"Motion.SignalChart",0],[0,"TypeOption",1,0],[0,"TypeOptionOvrCtrl",1,0],[1,"VelocityExpression",0,"Expression",0]],[],[]];
SPLM.Motion.DriverOperation = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.DriverOperation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.DriverOperation.Type = Object.freeze({
    "Undefined" : "Undefined", "Polynomial" : "Polynomial", "Harmonic" : "Harmonic", "Function" : "Function", "Articulation" : "Articulation", "Motor" : "Motor", "Control" : "Control", "Profile" : "Profile"});

SPLM.Motion.DriverOperation.IntegrationType = Object.freeze({
    "Displacement" : "Displacement", "Velocity" : "Velocity", "Acceleration" : "Acceleration"});

export default SPLM;